<template>
  <b-modal
    id="audit-log-modal"
    title="User Audit Logs"
    size="lg"
    centered
    hide-footer
    @shown="handleFetchAuditLogs"
    body-class="modal-body-scrollable"
  >
    <div>
      <b-table
        class="mt-1"
        :items="items"
        :fields="fields"
        show-empty
        responsive
        primary-key="id"
        thead-class="text-nowrap"
        :busy="loadingAudit"
      >
        <template #cell(status)>
          <div
            class="bg-success rounded-pill"
            style="width: 10px; height: 10px"
          ></div>
        </template>
        <template #cell(createdTime)="{ item }">
          <b-media vertical-align="center">
            <span class="text-nowrap">
              {{ format(new Date(item.createdTime), "yyyy-MM-dd HH:mm:ss") }}
            </span>
          </b-media>
        </template>

        <template #cell(createdByFullName)="{ item }">
          <b-media vertical-align="center">
            <span class="font-weight-bolder text-nowrap">{{
              item.createdByFullName || "-"
            }}</span>
          </b-media>
        </template>
        <template #cell(action)="{ item }">
          <b-media vertical-align="center">
            <span class="text-nowrap">{{ formatAction(item.action) }}</span>
          </b-media>
        </template>
        <template #cell(details)="{ item }">
          <b-media vertical-align="center">
            <span>{{ item.details || "-" }}</span>
          </b-media>
        </template>
        <template #cell(targetName)="{ item }">
          <b-media vertical-align="center">
            <span class="text-nowrap">{{ item.targetName || "-" }}</span>
          </b-media>
        </template>
        <template #cell(category)="{ item }">
          <b-media vertical-align="center">
            <div class="d-flex align-items-center" style="gap: 5px">
              <span class="text-nowrap">{{
                formatCategory(item.category)
              }}</span>
            </div>
          </b-media>
        </template>
      </b-table>
      <div
        v-if="paginationAudit.total > 0"
        class="d-flex align-items-center justify-content-between mt-1"
      >
        <div class="text-muted small">{{ paginationSummary }}</div>
        <div
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="page"
            :total-rows="paginationAudit.total"
            :per-page="paginationAudit.limit"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #first-text
              ><span class="text-success">First</span></template
            >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
            <template #last-text><span class="text-info">Last</span></template>
          </b-pagination>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BTable, BPagination, BMedia } from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";
export default {
  components: {
    BModal,
    BTable,
    BPagination,
    BMedia,
  },
  data() {
    const categories = [
      {
        value: null,
        label: "All Categories",
        icon: null,
        color: null,
      },
      {
        value: "user_management",
        label: "User Management",
        icon: "UsersIcon",
        color: "text-primary",
      },
      {
        value: "odds_management",
        label: "Odds Management",
        icon: "SignDollarIcon",
        color: "text-success",
      },
      {
        value: "customer_service",
        label: "Customer Service",
        icon: null,
        color: null,
      },
      {
        value: "system",
        label: "System",
        icon: null,
        color: null,
      },
      {
        value: "security",
        label: "Security",
        icon: null,
        color: null,
      },
      {
        value: "financial",
        label: "Financial",
        icon: null,
        color: null,
      },
    ];
    return {
      categories,
      fields: [
        { key: "status", label: "status" },
        { key: "createdTime", label: "timestamp" },
        { key: "createdByFullName", label: "user" },
        { key: "category", label: "category" },
        { key: "action", label: "action" },
        { key: "details", label: "details" },
        { key: "targetName", label: "target" },
        { key: "ipAddress", label: "IP Address" },
      ],
      items: [],
      page: 1,
    };
  },
  watch: {
    page() {
      this.handleFetchAuditLogs();
    },
  },
  computed: {
    ...mapState("user/detail", ["loadingAudit", "paginationAudit"]),
    paginationSummary() {
      const p = this.paginationAudit || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 items`
        : `Showing ${from} - ${to} of ${total} items`;
    },
  },
  methods: {
    ...mapActions("user/detail", ["getAuditLogsByUser"]),
    format,
    async handleFetchAuditLogs() {
      const result = await this.getAuditLogsByUser({
        userId: this.$route.params.id,
        page: this.page,
      });
      this.items = result;
    },
    formatCategory(category) {
      const found = this.categories.find((c) => c.value === category);
      return found ? found.label : category;
    },
    getIconCategory(value) {
      return this.categories.find((c) => c.value === value) || null;
    },
    formatAction(action) {
      if (!action) return "";
      return action
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
</script>

<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
